import "../css/Careers.css";

export default function Careers() {
  const email = "outreachmindsparkedutech@gmail.com";

  const mailtoLink = (role) =>
    `mailto:${email}?subject=${encodeURIComponent(
      `Application for ${role}`
    )}`;

  const internshipRoles = [
    {
      id: "training-software",
      number: "01",
      title: "Training & Software Development Intern",
      category: "Internship",
      accent: "yellow",
      tags: ["Hands-on", "STEM", "Classroom"],
      description:
        "Assist in delivering interactive robotics lessons, help students build and program robots, and design playful projects that make STEM fun and accessible.",
      responsibilities: [
        "Help run workshops and lab sessions (online/offline)",
        "Assist students with hardware & programming (Blockly / Scratch / Arduino)",
        "Prepare hands-on lesson materials and activity guides",
        "Support mentor-led assessment and progress tracking",
      ],
      meta: [
        {
          label: "Duration",
          value: "6 / 12 months",
        },
        {
          label: "Location",
          value: "Pune (On-Site)",
        },
      ],
      applyUrl: "https://forms.gle/HxT6MPCPuPhh7gMf7",
      buttonText: "Apply for Internship",
      external: true,
    },
    {
      id: "marketing-outreach",
      number: "02",
      title: "Marketing & Outreach Intern",
      category: "Internship",
      accent: "purple",
      tags: ["Communications", "Growth", "Social"],
      description:
        "Help us spread the word about MindSpark — plan campaigns, create social content, reach out to schools and communities, and measure engagement.",
      responsibilities: [
        "Support digital campaigns and content creation",
        "Community outreach to schools and parent groups",
        "Collect feedback and help refine program messaging",
        "Assist in event coordination and student sign-ups",
      ],
      meta: [
        {
          label: "Duration",
          value: "6 / 12 months",
        },
        {
          label: "Location",
          value: "Pune (On-Site)",
        },
      ],
      applyUrl: "https://forms.gle/BGX3oeWvPEAfWP4e6",
      buttonText: "Apply for Internship",
      external: true,
    },
  ];

  const jobRoles = [
    {
      id: "business-development",
      number: "03",
      title: "Marketing & Business Development Executive",
      shortTitle: "BDE",
      category: "Full-Time Opportunity",
      accent: "blue",
      tags: ["Sales", "Partnerships", "Growth"],
      description:
        "Drive business growth by building relationships, identifying new opportunities, and expanding MindSpark EduTech’s reach into schools, communities, and educational institutions.",
      responsibilities: [
        "Identify and connect with potential partner schools and organizations",
        "Pitch MindSpark’s STEM and robotics programs to decision makers",
        "Maintain and grow strong client relationships",
        "Collaborate with the marketing team to support campaigns",
        "Achieve monthly and quarterly sales targets",
      ],
      meta: [
        {
          label: "Experience",
          value: "0–1 years",
        },
        {
          label: "Eligibility",
          value: "Freshers welcome",
        },
        {
          label: "Location",
          value: "Pune (On-Site)",
        },
      ],
      applyUrl: mailtoLink(
        "Marketing & Business Development Executive (BDE)"
      ),
      buttonText: "Apply for BDE",
      external: false,
    },
  ];

  const renderRole = (role) => (
    <article
      key={role.id}
      className={`ms-careers-role ${role.accent}`}
    >
      {/* LEFT NUMBER */}
      <div className="ms-careers-role-number">
        {role.number}
      </div>

      {/* MAIN ROLE INFO */}
      <div className="ms-careers-role-main">
        <div className="ms-careers-role-topline">
          <span className="ms-careers-role-type">
            <i />
            {role.category}
          </span>

          {role.shortTitle && (
            <span className="ms-careers-short-title">
              {role.shortTitle}
            </span>
          )}
        </div>

        <h3>{role.title}</h3>

        <p className="ms-careers-role-description">
          {role.description}
        </p>

        <div className="ms-careers-role-tags">
          {role.tags.map((tag) => (
            <span key={tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* RESPONSIBILITIES */}
      <div className="ms-careers-responsibilities">
        <span className="ms-careers-small-label">
          WHAT YOU'LL WORK ON
        </span>

        <ul>
          {role.responsibilities.map((item) => (
            <li key={item}>
              <span className="ms-careers-check">
                ✓
              </span>

              <span>
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* META + APPLY */}
      <div className="ms-careers-role-footer">
        <div className="ms-careers-meta">
          {role.meta.map((item) => (
            <div
              key={`${role.id}-${item.label}`}
              className="ms-careers-meta-item"
            >
              <small>
                {item.label}
              </small>

              <strong>
                {item.value}
              </strong>
            </div>
          ))}
        </div>

        <a
          href={role.applyUrl}
          className="ms-careers-apply"
          target={role.external ? "_blank" : undefined}
          rel={
            role.external
              ? "noopener noreferrer"
              : undefined
          }
        >
          {role.buttonText}

          <span>→</span>
        </a>
      </div>

      <div className="ms-careers-role-accent" />
    </article>
  );

  return (
    <main className="ms-careers-page">
      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="ms-careers-hero">
        <div className="ms-careers-grid-bg" />

        <div className="ms-careers-glow ms-careers-glow-blue" />
        <div className="ms-careers-glow ms-careers-glow-yellow" />

        <div className="ms-careers-container">
          <div className="ms-careers-hero-layout">
            {/* LEFT */}
            <div className="ms-careers-hero-copy">
              <div className="ms-careers-kicker">
                <span />

                CAREERS AT MINDSPARK
              </div>

              <h1>
                Build meaningful work.
                <span> Inspire young minds.</span>
              </h1>

              <p>
                Be part of our mission to inspire young
                minds through robotics and STEM education.
                We're looking for enthusiastic people who
                are passionate about teaching, technology,
                innovation and growth.
              </p>

              <div className="ms-careers-actions">
                <a
                  href="#open-roles"
                  className="ms-careers-primary-btn"
                >
                  See Open Positions

                  <span>↓</span>
                </a>

                <a
                  href={`mailto:${email}`}
                  className="ms-careers-secondary-btn"
                >
                  Contact Careers
                </a>
              </div>

              <div className="ms-careers-hero-note">
                <div className="ms-careers-note-mark">
                  <span />
                  <span />
                </div>

                <div>
                  <small>
                    LEARNING THROUGH TECHNOLOGY
                  </small>

                  <strong>
                    Join the team building practical learning
                    experiences.
                  </strong>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="ms-careers-opportunity-board">
              <div className="ms-careers-board-header">
                <div>
                  <small>
                    CURRENT OPPORTUNITIES
                  </small>

                  <h2>
                    Open roles
                  </h2>
                </div>

                <span className="ms-careers-open-status">
                  <i />
                  Hiring
                </span>
              </div>

              <div className="ms-careers-board-list">
                <a
                  href="#internships"
                  className="ms-careers-board-row yellow"
                >
                  <span className="ms-careers-board-number">
                    01
                  </span>

                  <div>
                    <small>
                      INTERNSHIP
                    </small>

                    <strong>
                      Training & Software Development
                    </strong>
                  </div>

                  <span className="ms-careers-board-arrow">
                    ↘
                  </span>
                </a>

                <a
                  href="#internships"
                  className="ms-careers-board-row purple"
                >
                  <span className="ms-careers-board-number">
                    02
                  </span>

                  <div>
                    <small>
                      INTERNSHIP
                    </small>

                    <strong>
                      Marketing & Outreach
                    </strong>
                  </div>

                  <span className="ms-careers-board-arrow">
                    ↘
                  </span>
                </a>

                <a
                  href="#jobs"
                  className="ms-careers-board-row blue"
                >
                  <span className="ms-careers-board-number">
                    03
                  </span>

                  <div>
                    <small>
                      FULL-TIME
                    </small>

                    <strong>
                      Marketing & Business Development
                    </strong>
                  </div>

                  <span className="ms-careers-board-arrow">
                    ↘
                  </span>
                </a>
              </div>

              <div className="ms-careers-board-bottom">
                <span>
                  Pune
                </span>

                <i />

                <span>
                  On-Site
                </span>

                <i />

                <span>
                  MindSpark EduTech
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          OPEN ROLES
      ===================================================== */}

      <section
        id="open-roles"
        className="ms-careers-roles-section"
      >
        <div className="ms-careers-container">
          {/* ===============================================
              INTERNSHIPS
          =============================================== */}

          <div
            id="internships"
            className="ms-careers-role-group"
          >
            <div className="ms-careers-group-heading">
              <div>
                <div className="ms-careers-kicker">
                  <span />

                  INTERNSHIP OPPORTUNITIES
                </div>

                <h2>
                  Start your journey
                  <span> with MindSpark.</span>
                </h2>
              </div>

              <p>
                Gain hands-on experience, work closely with
                learning programs and contribute to
                technology-driven education.
              </p>
            </div>

            <div className="ms-careers-role-list">
              {internshipRoles.map(renderRole)}
            </div>
          </div>

          {/* ===============================================
              FULL TIME
          =============================================== */}

          <div
            id="jobs"
            className="ms-careers-role-group ms-careers-job-group"
          >
            <div className="ms-careers-group-heading">
              <div>
                <div className="ms-careers-kicker">
                  <span />

                  JOB OPPORTUNITIES
                </div>

                <h2>
                  Grow with a team
                  <span> creating impact.</span>
                </h2>
              </div>

              <p>
                Help expand MindSpark’s reach and build
                strong relationships with schools,
                communities and educational institutions.
              </p>
            </div>

            <div className="ms-careers-role-list">
              {jobRoles.map(renderRole)}
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          APPLICATION CONTACT
      ===================================================== */}

      <section className="ms-careers-contact">
        <div className="ms-careers-container">
          <div className="ms-careers-contact-panel">
            <div className="ms-careers-contact-copy">
              <small>
                DON'T SEE THE RIGHT ROLE?
              </small>

              <h2>
                Still interested in joining MindSpark?
              </h2>

              <p>
                Send your CV and a short note about why
                you'd like to join us. We welcome
                applicants from diverse backgrounds.
              </p>
            </div>

            <a
              href={`mailto:${email}`}
              className="ms-careers-email-btn"
            >
              <div>
                <small>
                  EMAIL YOUR CV
                </small>

                <strong>
                  {email}
                </strong>
              </div>

              <span>
                →
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
